import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { TEAM_MEMBERS } from '../../data/staticContent';

const Team = () => {
  const { t } = useLanguage();

  return (
    <section className="section-pad">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="section-title">{t('team.title')}</h2>
          <div className="divider-brand-center"></div>
          <p className="section-subtitle">{t('team.subtitle')}</p>
        </div>

        <div className="row g-4">
          {TEAM_MEMBERS.map(({ key, initials, avatarClass }, i) => (
            <div className="col-lg-4 col-md-6" key={key}>
              <div className={`team-card anim-fade-up anim-delay-${i + 1}`}>
                <div className={`team-avatar ${avatarClass}`}>{initials}</div>
                <div className="team-info">
                  <div className="team-name">{t(`team.${key}Name`)}</div>
                  <div className="team-role">{t(`team.${key}Role`)}</div>
                  <p className="team-desc mb-0">{t(`team.${key}Desc`)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Volunteer CTA */}
        <div className="mt-5 p-5 rounded-4 bg-card border border-site text-center">
          <h3 className="section-title mb-2">{t('team.volunteersTitle')}</h3>
          <p className="body-text mx-auto mb-4" style={{maxWidth:'520px'}}>{t('team.volunteersText')}</p>
          <Link to="/you-can" className="btn-brand">
            {t('team.volunteersCta')} <i className="bi bi-arrow-right"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Team;
